import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, Button, reportGroup, Tabs, Tab, reportControl, Table, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {ToastContainer, ToastStore} from 'react-toasts';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import _ from 'underscore';

import ReportsService from "../../services/reports-service";
import UsersService from "../../services/users-service";
import GLOBALS from '../../utils/Constants';

import './style.css';

var onChangeTimeOut;

class Reports extends Component {

    csv_report = null;
    
    tableData = {
        columns: [
            {
                label: 'Report Title',
                field: 'name',
                sort: 'asc',
                width: 350
            },
            {
                label: 'Actions',
                field: 'action',
                width: 150
            }
        ],
        rows: []
    }

    constructor(props, context) {
        super(props, context);
		
		const credentials =  UsersService.sharedInstance.getStoredCredentials().loginResponse;
		const license = credentials.data[0].User_License;

        this.state = {
			token: credentials.token_data.token,
            auth_username: credentials.data[0].User_ID,
            sub_user_id: credentials.data[0].recno,
            license: license,
            show: false,
            reports: [],
            itemToEditIndex: null,
            guiltyObject: null, //For Deletion
            showConfirmationModal: false ,
        }
		
		this.handleCSVFileChange = this.handleCSVFileChange.bind(this);
		this.submitReport = this.submitReport.bind(this);
        this.uploadReport = this.uploadReport.bind(this);
        this.fetchReports = this.fetchReports.bind(this);

        this.options = {
            // onRowClick: (row) => this.renderEditReport(row),
            hideSizePerPage: true,
            defaultSortName: 'name',  // default sort column name
            defaultSortOrder: 'asc'  // default sort order
        }
    }

    componentWillMount(){
        this.fetchReports();
    }

    render(){
      var itemToEditIndex = this.state.itemToEditIndex;

        return(
            <div className="reports-main-content">
                <div className="report-controls-div">
                  {/* <input type="file" id="file" ref="fileUploader" className="report-control form-control" placeholder="Browse your computer to upload a report..."/> */}
                  <input
                            type="file"
                            ref={(input) => { this.filesInput = input }}
                            name="file"
                            className="form-control"
                            onChange={this.handleCSVFileChange}
                            accept=".csv"
                      />
                  <Button className="control-btn green-btn upload-btn" onClick={this.submitReport}>Upload Report</Button>
                </div>
                <div className="reports-table">
                    <BootstrapTable width="100%" data={ this.tableData.rows } hover={true} keyField="id" search={true} pagination options={this.options} trClassName={"usersRow"}>
                        <TableHeaderColumn dataField='name' width="65%" dataSort dataFormat={this.renderEditReport}>Report Title</TableHeaderColumn>
                        <TableHeaderColumn dataField='' width="35%" dataFormat={this.renderActions}>Actions</TableHeaderColumn>
                    </BootstrapTable>
                </div>

                <Modal style={{marginTop: "10%"}}
					show={this.state.showConfirmationModal}
                    onExit={()=>{this.setState({showConfirmationModal: false, guiltyObject: null})}}>
                    <Modal.Header>
                      	<b style={{fontSize: 20}}>Confirm Deletion</b>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{textAlign: 'center'}}>Are you sure you want to delete "<b>{this.state.guiltyObject ? this.state.guiltyObject.name : ""}</b>"?</div>
                    </Modal.Body>
                    <Modal.Footer>
                      	<Button onClick={()=>{this.setState({showConfirmationModal: false})}}>Cancel</Button>
                      	<Button bsStyle="danger" onClick={()=>{this.onDeleteItem(this.state.guiltyObject)}}>Delete</Button>
                    </Modal.Footer>
                </Modal>
				<ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
			</div>
		)
    }

    renderEditReport = (cell, row, rowIndex, formatExtraData) => {
        if (this.state.itemToEditIndex != formatExtraData){
            return(
                <h5>{row.name}</h5>
            )
        }
        else {
            return (
                <div className="form-inline">
                    <input type="text" 
                        className="form-control edit-report-field" style={{textAlign: "center"}} 
                        value={this.state[row.id] != null ? this.state[row.id] : row.name}
                        onChange={(e)=>{
                            // this.onChangeExistingItemField(row, "name", e.target.value);
                            this.setState({ [row.id]: e.target.value });
                        }}/>
                    <button className="btn btn-primary" onClick={()=>this.onSaveButtonHandler(row.id)}>Save</button>
                </div>  
            )
        }
    }
    
    renderActions = (cell, row, rowIndex, formatExtraData) => {
        return(
            <div>
                <Button className="action-button">
                    <FontAwesomeIcon className="" icon="trash-alt" onClick={()=>{this.setState({guiltyObject: row, showConfirmationModal: true})}}/>
                </Button>
                <Button className="action-button">
                    <FontAwesomeIcon className="" icon="download" onClick={()=>{this.onDownload(row)}}/>
                </Button>
                <Button className="action-button" onClick={()=>{this.setItemToEdit(formatExtraData)}}>
                    <FontAwesomeIcon className=""  icon="pencil-alt"/>
                </Button>
            </div>
        )
    }

    setItemToEdit(index) {
		this.setState({
			itemToEditIndex: index == this.state.itemToEditIndex ? null : index
		})
    }

    onSaveButtonHandler(report_id){

        this.setState({
            itemToEditIndex: null
        });

        let params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.auth_username,
            "id": report_id,
            "name": this.state[report_id]
        }

        ReportsService.sharedInstance.editByName(params)
        .then((response) => {
            if (response == true){
                ToastStore.success("Successfully modified report!");
                this.fetchReports();
            }else {
                ToastStore.error("Report Update Failed! Error code: "+response.code_error);
            }
        })
    }

    onDeleteItem(item) {
      //API call to Delete

		this.setState({
            showConfirmationModal: false,
            itemToEditIndex: null
		}); 

        let params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.auth_username,
            "id": item.id
        }
          
        ReportsService.sharedInstance.delete(params)
        .then((response) => {
            if (response.success == 1){
                ToastStore.success("Successfully deleted report!");
                this.fetchReports();
            }else {
                ToastStore.error("Delete Report Failed! Error code: "+response.code_error);
            }
        })
    }

    onDownload(item) {
        // ToastStore.warning("Download function still under construction");
        var path = GLOBALS.CSA_REPORTS_S3_PATH + this.state.license + "/" + item.name + ".csv";
        window.open(path);
    }

    handleCSVFileChange = (event) => {
		this.csv_report = event.target.files[0];
    }

    fetchReports(){
        ReportsService.sharedInstance.fetchReports(this.state.license, this.state.auth_username, this.state.token)
        .then((response)=>{

            this.tableData.rows = [];
            response.map((item)=>{
                var item_data = {
                    "id": UsersService.sharedInstance.returnEmptyIfNull(item.id),
                    "name":  UsersService.sharedInstance.returnEmptyIfNull(item.name)
                }

                this.tableData.rows.push(item_data);

            });
            this.setState({reports: response});
        })
    }

	submitReport(){
		this.uploadReport(this.csv_report);
	}

	uploadReport(file) {
		if (file == null || file == ''){
            ToastStore.error("No Report CSV File Attached!");
            return;
        }

        let params = {
            "license":this.state.license,
            "auth_username":this.state.auth_username,
            "token":this.state.token,
            "file": file,
            "sub_user_id": this.state.sub_user_id
        };

        ReportsService.sharedInstance.upload(params)
        .then((response)=>{
            if (response){
                ToastStore.success("Successfully Uploaded Report!");
                this.csv_report = null;
                this.fetchReports();
            }
        })
        .catch((error)=>{
            ToastStore.error("Failed to upload the report file!");
            console.log(error);
        });
	}

}

export default Reports;
